import {Box} from '@buncha/components/core/view';
import React from 'react';

const ChatOpener = () => {
  return <Box />;
};

export default React.memo(ChatOpener);
